import React from "react";
import { Card } from "antd";

const Widget = ({ children, className }) => {
  return <Card className={`gx-card-widget ${className}`}>{children}</Card>;
};

export default Widget;
